// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import HealthTag from '../../HealthTag'
import classNames from 'classnames'
import './index.less'
import { connect } from 'react-redux'
import { Spin, Col, Row, Space } from 'antd'
import locationPng from 'assets/images/location.png'
import { CameraActivityCircle } from 'components/camera-activity-circle'
import { OnlineHoursCell } from 'components/camera-details/OnlineHoursCell'

const deviceDictionary = [
  {key: 'device_id',name: 'device ID', show: false, suffix: ''},
  {key: 'engine_rpm',name: 'engine RPM', show: true, suffix: 'rpm'},
  {key: 'mileage',name: 'mileage', show: true, suffix:'km'},
  {key: 'oil_volume',name: 'oil volume', show: false, suffix: ''},
  {key: 'speed',name: 'speed', show: true,suffix: 'km/h'},
  {key: 'vehicle_malfunction_code',name: 'vechile malfunction code', show: true, suffix: ''},
  {key: 'IMEI',name: 'IMEI', show: true,suffix: ''},
  {key: 'IMSI',name: 'IMSI', show: true,suffix: ''},
  {key: 'ble_mac_addr',name: 'ble mac address', show: true,suffix: ''},
  {key: 'wifi_mac_addr',name: 'wifi mac address', show: true,suffix: ''},
]
const DongleStatus = (props) => {
  const { device, loading } = props
  return (
    <Spin spinning={loading}>
      <div className={classNames('camera-status', { loading })}>
        <div className='head'>
          <Row justify='space-between' align='middle'>
            <Col>
              <Space size={4}>
                <div className='camera-id'>{device.deviceID}</div>
                <CameraActivityCircle status={device.onlineStatus} />
              </Space>
            </Col>
            <Col>
              {/*<HealthTag style={{ marginRight: '0px' }} className='health-status' status={device.status} />*/}
            </Col>
          </Row>
          <div className='gray-text text-loading-effect'>World Cam</div>
        </div>
        <div className='content'>
          <div className='items'>
            {
              deviceDictionary
                .filter(item => item.show)
                .map(item => (
                  <div className={'item'} key={item.key}>
                    <div className='value text-loading-effect'>{device[item.key] } { item.suffix}</div>
                    <div className='gray-text'>{item.name}</div>
                  </div>
                ))

            }
          </div>
        </div>
      </div>
    </Spin>
  )
}

export default connect(
  ({ loading, cameras }) => ({
    loading: loading.effects.cameras.fetchCameraDetails,
    cameraDetails: cameras.cameraDetails
  }),
  ({ cameras }) => ({
    fetchCameraDetails: cameras.fetchCameraDetails
  }),
  (propsFromState, propsFromDispatch, propsFromParent) => {
    const cameraDetails = propsFromState.cameraDetails
    const combined = { ...propsFromState, ...propsFromDispatch, ...propsFromParent }
    if (combined.camera) {
      combined.camera = { ...combined.camera, ...cameraDetails[combined.camera.deviceID] }
    }
    return combined
  }
)(DongleStatus)
